// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchSpringMerchandising_wrapper__UTQMx","card":"SearchSpringMerchandising_card__u9tOh","inner":"SearchSpringMerchandising_inner__FoJqC"};